import { format, parse, isValid } from "date-fns";

export const formatAppDate = (dateStr: string | Date | null | undefined): string => {
  if (!dateStr) return "-";

  let dateObj: Date | null = null;

  if (dateStr instanceof Date) {
    dateObj = dateStr;
  } else if (typeof dateStr === "string") {
    // Check if it's already in our preferred format but we want to ensure standard formatting
    // Attempt standard JS parse first (handles ISO strings, e.g. "2026-09-07T00:00:00Z")
    const standardDate = new Date(dateStr);
    
    // JS Date can incorrectly parse some strings. If it contains "T" or "-" and is valid
    if (isValid(standardDate) && !isNaN(standardDate.getTime()) && (dateStr.includes("T") || dateStr.match(/^\d{4}-\d{2}-\d{2}/))) {
      dateObj = standardDate;
    } else {
      // Try parsing common formats
      const formatsToTry = [
        "dd-MM-yyyy HH:mm:ss",
        "dd-MM-yyyy",
        "MM/dd/yyyy",
        "dd/MM/yyyy",
        "yyyy-MM-dd"
      ];

      for (const fmt of formatsToTry) {
        const parsed = parse(dateStr, fmt, new Date());
        if (isValid(parsed) && !isNaN(parsed.getTime())) {
          dateObj = parsed;
          break;
        }
      }
      
      // Fallback
      if (!dateObj && isValid(standardDate) && !isNaN(standardDate.getTime())) {
        dateObj = standardDate;
      }
    }
  }

  if (dateObj && isValid(dateObj)) {
    return format(dateObj, "dd-MM-yyyy");
  }

  // If all parsing fails, return original string as fallback
  return String(dateStr);
};
